import { frontendURL } from '../../../helper/URLHelper';

import OrdersIndex from './OrdersIndex.vue';
import OrderDetails from './OrderDetails.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/orders'),
      name: 'orders_list',
      meta: { permissions: ['administrator', 'agent', 'custom_role'] },
      component: OrdersIndex,
    },
    {
      path: frontendURL('accounts/:accountId/orders/segments/:segmentId'),
      name: 'orders_segments_index',
      meta: { permissions: ['administrator', 'agent', 'custom_role'] },
      component: OrdersIndex,
    },
    {
      path: frontendURL('accounts/:accountId/orders/:orderId'),
      name: 'orders_details',
      meta: { permissions: ['administrator', 'agent', 'custom_role'] },
      component: OrderDetails,
      props: true,
    },
  ],
};
